/**
 * Created by Jerker Nord on 2021-08-26.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {TheBorder} from "../TheBorder";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TheBorderSound} from "../sound/TheBorderSound";

export class TheBorderBigWinView extends PIXI.Container implements StageLayer {
    private _countUp: BasicBitmapCountUp;
    private _bwSpine: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.name = "TheBorderBigWinView";
        this.init();
    }

    public getCountUpScaleAnimation(duration: number, ease: string, to: number, from?: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (from != undefined) {
            tl.add(() => {
                this._countUp.scale.set(from, from)
            });
        }
        tl.add(gsap.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease}))

        return tl;
    }

    public precalculateScale(endValue: number): void {
        this._countUp.stopAt(0);
        this._countUp.preCalculateScale(0, endValue);
    }

    public show(duration: number): gsap.core.Timeline {
        TheBorder.keypadPlugin.setWin(0, true, TheBorder.isWinBelowStake());
        const tl = gsap.timeline();
        tl.add(() => {
            this.alpha = 0;
            this.visible = true;
            this._countUp.alpha = 0;
        });
        tl.add(gsap.to(this, {duration: duration, alpha: 1, ease: "none"}));

        return tl;
    }

    public hide(duration: number = 0.0001): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add([
            TheBorder.blackOverlay.toggleOverlay(false, 0, duration),
            gsap.to(this, {duration: duration, alpha: 0})
        ]);
        tl.add(() => {
            this.visible = false;

            this._bwSpine.forEach((item: PIXI.spine.Spine) => {
                item.visible = false;
                item.state.clearTracks();
            });
        });

        return tl;
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (level === 1) {
            tl.add(TheBorder.blackOverlay.toggleOverlay(true, 0.85, 0.2), 0);
        }
        tl.add([
            this._countUp.getCountAnimation(countFrom, countTo, duration),
            () => {
                gsap.to(this._countUp, {duration: 0.2, alpha: 1});

                TheBorder.soundPlayer.playSound(TheBorderSound.BIG_WIN_EFFECTS[level]);
                TheBorder.soundPlayer.playNonLoopSound(TheBorderSound.BIG_WIN_MUSICS[level]);
            }
        ], 0);
        tl.add(() => {
            const anim: PIXI.spine.Spine = this._bwSpine[level - 1];
            if (!anim.visible) {
                anim.visible = true;
                anim.updateTransform();
            }
            anim.state.clearTracks();
            anim.skeleton.setSlotsToSetupPose();
            anim.skeleton.setToSetupPose();
            anim.state.setAnimation(0, "animation", false);

            if (level > 1) {
                this._bwSpine[level - 2].visible = false;
                this._bwSpine[level - 2].state.clearTracks();
            }
        }, "<");

        const scale = gsap.timeline();
        scale.add(this.getCountUpScaleAnimation(0.1, "power2.in", 1.2));
        scale.add(this.getCountUpScaleAnimation(0.2, "power2.out", 1.0));
        scale.add(this.getCountUpScaleAnimation(tl.duration() - 0.3, "power2.in", 0.8));
        tl.add(scale, 0);
        return tl;
    }

    private init(): void {
        const numLevels: number = 5,
            spineNames: string[] = [TheBorderGameAssets.BW_V1_SPINE, TheBorderGameAssets.BW_V2_SPINE, TheBorderGameAssets.BW_V3_SPINE, TheBorderGameAssets.BW_V4_SPINE, TheBorderGameAssets.BW_V5_SPINE];
        for (let i: number = 0; i < numLevels; i++) {
            const item: PIXI.spine.Spine = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(spineNames[i]));
            item.visible = false;
            item.position.set(360);
            this._bwSpine.push(item);
            this.addChild(item);
        }

        this._countUp = new BasicBitmapCountUp({
            fontName: TheBorderGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize: 190,
            tint: 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this._countUp.scale.set(0.8, 0.8);
        this._countUp.stopAt(0);
        this._countUp.position.set(360, 390);

        this.addChild(this._countUp);
        this.hide();
    }
}